import { useEffect } from 'react';
import { userMenu_fetchItems } from './userMenuService';

export const toggleMenu = (key,setOpenMenu,openMenu) => {
  setOpenMenu(openMenu === key ? null : key);
};

export const handleGetUserMenu=async({ data,
  setMenuData, setLoading})=>{  
 setLoading(true);
 try {    
   const resData=await userMenu_fetchItems(data);
   
   setMenuData(resData?.data);     
 } catch (error) {
   console.log("Something went wrong! Please try again", 'danger');
 }finally{
   setLoading(false);
 }
}

export const useDefaultLoad = ({ 
  filter, setMenuData, setLoading }) => {
  useEffect(() => {          
      let data=filter;
      handleGetUserMenu({ data, setMenuData, setLoading})      
  }, []);
};